import React from 'react';
import { Controls, FinderWrapper, LogoLink, SizeContainer, SupportTooltipBody, Wrapper } from './header.styles';
import { ROUTE_ADMIN_MAIN } from '@shared/config/routes/routes';
import { IconHeadphone } from '@shared/icon/icon-headphone/icon-headphone';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { IconCircleButton } from '@shared/ui/button-circle-icon/button-circle-icon';
import { Logo } from '@shared/icon/logo/logo';
import { CardCurrentUserProfile } from '@widgets/card-current-user-profile/ui/card-current-user-profile';
import { CreateFeedback } from '@features/feedback/create-feedback-request/ui/create-feedback';
import { useDispatch } from 'react-redux';
import { setIsShowCreateFeedbackRequest } from '@entities/feedback/model/slice';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { getCurrentUserRole } from '@shared/lib/utils/get-current-user-role/get-current-user-role';
import { UserRoles } from '@shared/model/user';
import { useLocation } from 'react-router-dom';

export const Header: React.FC = () => {
    const { pathname } = useLocation();
    const user = useCurrentUserSelector();
    const role = getCurrentUserRole(user);

    const dispatch = useDispatch();

    const handleOpenFeedback = () => {
        dispatch(setIsShowCreateFeedbackRequest(true));
    };

    return (
        <Wrapper>
            <SizeContainer>
                {pathname === ROUTE_ADMIN_MAIN ? (
                    <Logo />
                ) : (
                    <LogoLink to={ROUTE_ADMIN_MAIN}>
                        <Logo />
                    </LogoLink>
                )}
                <FinderWrapper>{/* <Search placeholder='Искать продукт, мероприятие...' /> */}</FinderWrapper>
                <Controls>
                    {role !== UserRoles.Admin && (
                        <Tooltip>
                            <IconCircleButton>
                                <IconHeadphone />
                            </IconCircleButton>
                            <SupportTooltipBody>
                                {/* Возможно понадобится в будущем */}
                                {/* <SupportTooltipText>
                                    <Typography size='subtitle3'>Служба техподдержки</Typography>
                                    <PhoneContact>
                                        <Typography size='body2_short'>Тел.: </Typography>
                                        <PhoneLink size='sm'>8(800)000-00-00</PhoneLink>
                                    </PhoneContact>
                                </SupportTooltipText> */}
                                <Button size='s' buttonType='secondary' onClick={handleOpenFeedback}>
                                    Написать обращение
                                </Button>
                            </SupportTooltipBody>
                        </Tooltip>
                    )}
                    <CardCurrentUserProfile />
                </Controls>
            </SizeContainer>
            <CreateFeedback />
        </Wrapper>
    );
};
